<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i>&nbsp;{{ formatDate(counsel.counseledAt) }}</span>
        </div>
        <div class="card-body">
          <form novalidate name="counselEditForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">担当者</label><p>{{ counsel.counselor }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">実施メニュー</label><p>{{ counsel.trainingProgram?.name }}</p></div></div>
              <div class="form-group row"><div class="col-md-12"><label class="col-form-label">100日後の目標</label><p>{{ counsel.aimIn100Days }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">体重（kg）</label><p>{{ counsel.weight }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">体脂肪率（％）</label><p>{{ counsel.bodyFatPercentage }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">筋肉量（kg）</label><p>{{ counsel.muscleMass }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">太もも周り（cm）</label><p>{{ counsel.thighCircumference }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">お尻周り（cm）</label><p>{{ counsel.hipCircumference }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">お腹周り（cm）</label><p>{{ counsel.abdominalCircumference }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label">二の腕周り（cm）</label><p>{{ counsel.armCircumference }}</p></div></div>
              <div class="form-group row"><div class="col-md-12"><label class="col-form-label">1日にとるべき理想の摂取カロリー（kcal）</label><p>{{ counsel.caloriesToTake | number:'1.1-1' }}</p></div></div>
              <div class="form-group row"><div class="col-md-4"><label class="col-form-label"></label></div></div>
              <div class="form-group row"><div class="col-md-12"><label class="col-form-label">トレーナーコメント</label>
                <textarea class="form-control bg-white" rows="5" [ngModel]="counsel.note" [ngModelOptions]="{standalone: true}" readonly></textarea>
              </div></div>
              <div class="form-group row"><div class="col-md-12"><label class="col-form-label">次回までの目標</label><p>{{ counsel.aimInNextTime }}</p></div></div>
              <div class="form-group align-items-end">
                <div>
                  <label class="col-form-label">トレーニング画像:　{{ imgCount }}/4 アップロード済</label>
                  <div class="d-none d-sm-block">
                    <button class="btn btn-success" data-toggle="modal" data-target="#imageUploadModal" (click)="clearMyPicture()" [disabled]="imgCount == 4">
                      <i class="fa s-icon-plus fa-fw"></i><span>&nbsp;アップロード</span>
                    </button>
                  </div>
                  <div class="d-block d-sm-none">
                    <button class="btn btn-success col-12" data-toggle="modal" data-target="#imageUploadModal" (click)="clearMyPicture()" [disabled]="imgCount == 4">
                      <i class="fa s-icon-plus fa-fw"></i><span>&nbsp;アップロード</span>
                    </button>
                  </div>
                </div>
                <label class="col-form-label"></label>
              </div>
            </div>
          </div>
          </form>
          <div class="row">
            <div class="d-none d-sm-block col-md-12 text-right">
              <button routerLink="/counsel" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            </div>
            <div class="d-block d-sm-none col-12">
              <button routerLink="/counsel" class="btn bg-close text-white col-12 form-group"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Image Upload Modal -->
  <div class="modal fade" id="imageUploadModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">トレーニング画像アップロード</h5>
          <button type="button" class="close" data-dismiss="modal" [disabled]="isUploading"><span>&times;</span></button>
        </div>
        <div class="modal-body">
          @if (uploadMessage) { <div class="alert alert-info" role="alert">{{ uploadMessage }}</div> }
          @if (uploadUncertain) { <button type="button" class="btn btn-light" (click)="refreshUploadState()" [disabled]="isUploading">保存状態を再取得</button> }
          <div class="input-group">
            <label class="input-group-btn">
              <span class="btn btn-light">
                <i class="fa s-icon-image"></i>&nbsp;ファイル選択
                <input type="file" class="d-none" accept=".jpg,.jpeg,.png" (change)="onFilesChange($event)" [disabled]="isUploading || uploadUncertain" multiple>
              </span>
            </label>
            <input [ngModel]="myPictureInfo" type="text" class="form-control bg-white border-0" readonly>
          </div>
          <label class="col-form-label">.jpg, .jpeg, .png形式の画像が登録可能です。</label>
          @if (myPicture.length > 4 - imgCount) {
            <label class="col-form-label text-danger">※選択できる画像は{{ 4 - imgCount }}ファイルまでです。</label>
          }
          @if (isIncorrectType) {
            <label class="col-form-label text-danger">※「.jpg, .jpeg, .png」形式以外の画像が選択されています。</label>
          }
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" data-dismiss="modal" [disabled]="isUploading"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
          <button class="btn btn-success" type="button" (click)="upload()" [disabled]="!canUpload || isUploading">
            <i class="fa icon-arrow-up-circle"></i>&nbsp;アップロード
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
